export function resolveLoginReturnTo(stateFrom: string | undefined, search: string) {
  if (isSafeLocalReturnUrl(stateFrom)) return stateFrom;

  const queryReturnUrl = new URLSearchParams(search).get('ReturnUrl');
  return isSafeLocalReturnUrl(queryReturnUrl) ? queryReturnUrl : '/';
}

function isSafeLocalReturnUrl(value: string | null | undefined): value is string {
  if (!value?.startsWith('/') || value.startsWith('//')) return false;

  try {
    const localOrigin = 'https://megatraderdx.local';
    return new URL(value, localOrigin).origin === localOrigin;
  } catch {
    return false;
  }
}
